import React, { memo } from 'react';
import classNames from 'classnames';

import Popup from '../../helpers/Popup';
import Button from '../../helpers/Button';
import Input from '../../helpers/Input';
import Select from '../../helpers/Select';

import style from './style.module.css';

const StatusCodePopup = props => {
  const { onSave, onChange, buyer, statuses, statusUpdate } = props;
  const footer = (
    <Button
      key="save"
      className="btn-primary"
      data-dismiss="modal"
      loading={statusUpdate.get('waiting')}
      onClick={onSave}
      autoFocus
    >
      Save
    </Button>
  );
  const start = statusUpdate.get('start', '');
  const mid = statusUpdate.get('mid', '');
  const end = statusUpdate.get('end', '');

  return (
    <Popup footer={footer} header="Status Code Update" id="statusCodePopup">
      <div>
        Buyer: <strong>{buyer}</strong>
      </div>
      <div className={style.panel}>
        <div className={classNames(style.status, style.start)}>
          <Input name="start" showLabel={false} value={start} readOnly />
        </div>
        <div className={classNames(style.status, style.up)}>⇗</div>
        <div className={classNames(style.status, style.mid)}>
          <Select
            label="Status"
            name="mid"
            onChange={onChange}
            options={statuses}
            selectClassName="input-sm"
            value={mid}
            showValue
          />
        </div>
        <div className={classNames(style.status, style.down)}>⇘</div>
        <div className={classNames(style.status, style.end)}>
          <Input name="end" showLabel={false} value={end} readOnly />
        </div>
      </div>
    </Popup>
  );
};

export default memo(StatusCodePopup);
